const graphicStorageBasePath = '/graphic-storage';


const GraphicStorageConst = {
   basePath: graphicStorageBasePath
};

export default GraphicStorageConst;
